import React from "react";
import clsx from "clsx";
import "./Button.css";

export type ButtonVariant = "primary" | "neutral";

export type ButtonSize = "md" | "sm";

export type ButtonProps = React.ButtonHTMLAttributes<HTMLButtonElement> & {
  variant?: ButtonVariant;
  size?: ButtonSize;
};

export function Button({
  variant = "primary",
  size = "md",
  type = "button",
  className,
  ...rest
}: ButtonProps) {
  return (
    <button
      type={type}
      className={clsx(
        "btn",
        `Button--${variant}`,
        size === "sm" && "Button--small",
        className,
      )}
      {...rest}
    />
  );
}
